var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useContext, useState, useMemo, } from 'react';
import { LoadingBounce } from '@michelin/acid-components';
import { useGetSelectedLocationAccountNumber } from '../../hooks/useGetSelectedLocationAccountNumber';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
export default function SelectedAccountWatchdog(_a) {
    var children = _a.children, waitForAccountSelector = _a.waitForAccountSelector, _b = _a.showLoadingBounce, showLoadingBounce = _b === void 0 ? false : _b;
    var _c = useContext(CentralProviderContext), selectedGrantLocation = _c.selectedGrantLocation, selectingGrant = _c.selectingGrant;
    var selectedLocationStr = JSON.stringify(selectedGrantLocation);
    var selectedLocationAccountNumber = useGetSelectedLocationAccountNumber();
    var _d = __read(useState(selectedLocationAccountNumber), 2), key = _d[0], setKey = _d[1];
    useEffect(function () { return setKey(selectedLocationAccountNumber); }, [selectedLocationStr]);
    return useMemo(function () {
        // we must wait if selectingGrant is true OR undefined
        // So, don't change && selectingGrant !== false to just selectingGrant
        // eslint-disable-next-line no-lone-blocks
        if (waitForAccountSelector && selectingGrant !== false) {
            return showLoadingBounce ? React.createElement(LoadingBounce, { style: { height: '90vh' } }) : React.createElement(React.Fragment, null);
        }
        return (React.createElement(React.Fragment, { key: "remount-".concat(key) }, children));
    }, [key, waitForAccountSelector, selectingGrant]);
}
//# sourceMappingURL=SelectedAccountWatchdog.js.map